import { ReactElement } from 'react';

import { BindingCreator } from '@dreryk/react-common';

import { settingsTranslationKeys } from '../../../../translations';

import { StyledAllowAppointmentRequestsField } from './AllowAppointmentRequestsField.styled';

type AllowAppointmentRequestsFormBeanPart = {
   allowAppointmentRequests: boolean;
};

type AllowAppointmentRequestsFieldProps = {
   register: BindingCreator<AllowAppointmentRequestsFormBeanPart>;
};

export const AllowAppointmentRequestsField = (props: AllowAppointmentRequestsFieldProps): ReactElement => {
   return (
      <StyledAllowAppointmentRequestsField
         controller={props.register('allowAppointmentRequests')}
         testId={'allowAppointmentRequests'}
         label={settingsTranslationKeys.allowAppointmentRequests}
      />
   );
};
